import { createAsyncThunk } from "@reduxjs/toolkit";
import { AxiosError } from "axios";
//
import categoryApi from "api/categoryApi";
import { ApiErrorMessage, ApiResponse, IPaginatedResponse } from "api/types/_base";
import { ICategory, ICategoryPayload, ICategoryQuery, IOrderCategoryPayload, IUpdateStatusCategoryPayload } from "api/types/_category";

export const getCategories = createAsyncThunk<
  ApiResponse<IPaginatedResponse<ICategory>>,
  ICategoryQuery,
  { rejectValue: string }
>("categories/get", async (params, { rejectWithValue }) => {
  try {
    return await categoryApi.getCategories(params);
  } catch (error: unknown) {
    if (error instanceof AxiosError) {
      return rejectWithValue(error.response?.data?.message ?? "Request failed");
    }

    if (error instanceof Error) {
      return rejectWithValue(error.message);
    }
    return rejectWithValue("Unknown error");
  }
});


export const updateStatusCategory = async (id: number, data: IUpdateStatusCategoryPayload): Promise<ApiResponse<ICategory> | ApiErrorMessage> => {
  try {
    return await categoryApi.updateStatus(id, data);
  } catch (error) {
    return error as ApiErrorMessage;
  }
};

export const updateCategory = async (id: number, data: ICategoryPayload): Promise<ApiResponse<ICategory> | ApiErrorMessage> => {
  try {
    const response = await categoryApi.updateCategory(id, data);
    return response;
  } catch (error) {
    return error as ApiErrorMessage;
  }
};

export const deleteCategory = async (id: number): Promise<ApiResponse<ICategory> | ApiErrorMessage> => {
  try {
    const response = await categoryApi.deleteCategory(id);
    return response;
  } catch (error) {
    return error as ApiErrorMessage;
  }
};

export const orderCategory = async (params: IOrderCategoryPayload[]): Promise<ApiResponse<ICategory> | ApiErrorMessage> => {
  try {
    const response = await categoryApi.orderCategory(params);
    return response;
  } catch (error) {
    return error as ApiErrorMessage;
  }
};